




























import { defineComponent } from "@vue/composition-api";
import { StoryView } from "@scrile/api-provider/dist/api/StoriesProvider";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import InfiniteScroll from "@/components/InfiniteScroll";
import StoryStatisticViewsItem from "../StoryStatisticViewItem";

export default defineComponent({
  name: "StoryStatisticViewsList",
  components: { BaseSpinner, StoryStatisticViewsItem, CustomScroll, BaseIcon, InfiniteScroll },
  props: {
    items: { type: Array as () => StoryView[], required: true },
    likes: { type: Number, required: true },
    enableScroll: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
  },
});
